export const formatShippingUnitName = (unit: string): string => {
  if (unit === "PAL") return "Paleta";
  if (unit === "PAL^") return "Paleta";
  if (unit === "PAL+") return "Paleta + dokładka";
  if (unit.startsWith("MIX")) return "Paleta MIX";
  if (unit.startsWith("mix")) return "Półpaleta";

  const fillerRegex = /(S|D)(\d+[A-Za-z]+)\'/;
  const fillerMatch = unit.match(fillerRegex);
  if (fillerMatch) {
    const [_, type, size] = fillerMatch as [any, "S" | "D", string];
    let str = "Miejsce na prod. ";
    if (type === "D") str += "dysp.";
    if (type === "S") str += "suchy";
    str += " " + size;
    return `[${str}]`;
  }

  return unit;
};
